export const demoRegistries = [
  {
    id: "94d90206-cc74-4402-aef3-6e7e3f9c2047",
    code: "ICX",
    shortName: "ICX",
    fullName: "International Carbon Exchange",
    __typename: "Registry",
  },
  {
    id: "ed9ebda5-cf5a-4f80-a2b1-be3667d5b6b7",
    code: "ERCOT",
    shortName: "ERCOT",
    fullName: "Electric Reliability Council of Texas",
    __typename: "Registry",
  },
  {
    id: "37e874c2-d028-47fe-8e59-3f90d4503ca5",
    code: "MRETS",
    shortName: "M-RETS",
    fullName: "Midwest Renewable Energy Tracking System",
    __typename: "Registry",
  },
];
